import { createFileRoute } from '@tanstack/react-router'
import { FeatureFlagsPage } from '@/pages/feature-flags/FeatureFlagsPage'

export const Route = createFileRoute('/_auth/feature-flags')({
  component: FeatureFlagsPage,
})
